var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrowDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.01,
    height: 8.313,
    viewBox: "0 0 10.01 8.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91354",
    d: "M9.447 4.942h.016-6.7L4.87 7.048a.553.553 0 0 1 0 .777l-.328.328a.548.548 0 0 1-.774 0L.16 4.545a.552.552 0 0 1 0-.776L3.769.16a.549.549 0 0 1 .774 0l.327.327a.542.542 0 0 1 .16.387.526.526 0 0 1-.16.379L2.741 3.375h6.714a.567.567 0 0 1 .555.561V4.4a.556.556 0 0 1-.563.542z",
    style: {
      fill: "#6e6a65"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowDark);
export default __webpack_public_path__ + "static/media/left-arrow-dark.svg";
export { ForwardRef as ReactComponent };